










import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class Overlay extends Vue {
  @Prop({ default: "#ffffff" })
  backgroundColor?: string;

  @Prop({ default: false })
  fadeOut?: boolean;

  show = false;
  showOverlay(push: () => void): void {
    this.show = !this.show;
    setTimeout(() => {
      push();
      if (this.fadeOut) {
        setTimeout(() => {
          this.show = !this.show;
        }, 1000);
      }
    }, 300);
  }

  get background(): string {
    return `background: ${this.backgroundColor}`;
  }
}
